import { render, staticRenderFns } from "./ProductInventoryRestock.vue?vue&type=template&id=4734b020&"
import script from "./ProductInventoryRestock.vue?vue&type=script&lang=ts&"
export * from "./ProductInventoryRestock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports